module.exports = __webpack_public_path__ + "img/harrys_rubber_arm.641d4076.jpg";